import { CLOSURE_WINDOWS } from "@/constants";

export type ParkStatus = "closed" | "soon" | "open";

/**
 * Park status today from CLOSURE_WINDOWS (moved here from the old
 * ClosureStatusBanner so the hero chip and the stickers share one source).
 */
export function getParkStatus(now = new Date()): {
  status: ParkStatus;
  label: string;
  detail: string;
} {
  const y = now.getFullYear();
  const resolved = CLOSURE_WINDOWS.map((w) => ({
    start: new Date(y, w.startMonth - 1, w.startDay),
    end: new Date(y, w.endMonth - 1, w.endDay, 23, 59, 59),
    label: w.short,
    full: w.full,
  }));

  for (const w of resolved) {
    if (now >= w.start && now <= w.end) {
      return { status: "closed", label: "Parque cerrado", detail: w.label };
    }
  }

  const ms14 = 14 * 24 * 60 * 60 * 1000;
  for (const w of resolved) {
    const diff = w.start.getTime() - now.getTime();
    if (diff > 0 && diff <= ms14) {
      return { status: "soon", label: "Cierre próximo", detail: w.full };
    }
  }

  const next = resolved.find((w) => now < w.start) ?? resolved[0];
  return { status: "open", label: "Parque abierto", detail: `Próximo cierre: ${next.label}` };
}
